import CrossIcon from 'src/icons/cross';
import DownIcon from 'src/icons/down';

const Modal = ({ isOpen, setIsOpen, title, className, hasBackBtn, onBackBtnClick, children }) => {
    if (!isOpen) return;
    return (
        <div
            className="modal-container fixed w-screen h-screen top-0 left-0 flex justify-center items-center z-20 bg-black/25"
            onClick={(e) => {
                if (!e.target.className.includes('modal-container')) return;
                setIsOpen(false);
            }}
        >
            <div className={'max-h-screen bg-white rounded-xl h-min px-12 py-10 ' + (className ?? '')}>
                <div className="flex justify-between items-center mb-6">
                    {hasBackBtn ? (
                        <button onClick={onBackBtnClick}>
                            <DownIcon color={'#000000'} className="rotate-90" />
                        </button>
                    ) : (
                        <div className="w-6"></div>
                    )}
                    <span className="font-bold text-lg">{title}</span>
                    <CrossIcon onClick={() => setIsOpen(false)} className="cursor-pointer" />
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;
